import { createAsyncThunk } from "@reduxjs/toolkit";
import checkoutApi from "services/checkoutApi";
import { CheckoutItemProps } from "./types.store";
import { setIsSpinnerVisible } from "../AppConfig/index.store";
import Axios from "axios";

export const handleGetCheckoutItemsRequest = createAsyncThunk<
  CheckoutItemProps[],
  void
>("getCheckoutItems", async (_, { rejectWithValue, dispatch }) => {
  const queryParams = {
    limit: 50,
    statuses: "open",
  };
  try {
    dispatch(setIsSpinnerVisible(true));
    const { data } = await checkoutApi.get(`/v1/sessions`, {
      params: queryParams,
    });
    return data;
  } catch (err) {
    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});

export const handleGetScheduledCheckoutItemsRequest = createAsyncThunk<
  {
    items: CheckoutItemProps[];
    pagination: { count: number; totalCount: number; hasMore: boolean };
  },
  { dealerId: string; limit?: number; offset?: number }
>(
  "getScheduledCheckoutItems",
  async (
    { dealerId, limit = 10, offset = 0 },
    { rejectWithValue, dispatch },
  ) => {
    const queryParams = {
      limit,
      offset,
      statuses: "scheduled",
    };

    try {
      dispatch(setIsSpinnerVisible(true));

      const { data } = await checkoutApi.get(
        `/v1/dealers/${dealerId}/sessions`,
        {
          params: queryParams,
        },
      );
      const items = data.data || [];
      const pagination = data.pagination || { count: 0, totalCount: 0 };
      const hasMore = offset + items.length < pagination.totalCount;

      return {
        items,
        pagination: {
          count: pagination.count,
          totalCount: pagination.totalCount,
          hasMore,
        },
      };
    } catch (err) {
      if (Axios.isAxiosError(err) && err && err.response) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err);
    } finally {
      dispatch(setIsSpinnerVisible(false));
    }
  },
);
